if (!customElements.get("ff-retail-page")) {
  customElements.define(
    "ff-retail-page",
    class FfRetailPage extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.parentElement.style.display = "inline-block";
        this.parentElement.classList.add("ff-section-main-container")
        this.alternativeTitle = document.querySelector(".ff-alternative-title-container");
        if (this.alternativeTitle) {
          this.alternativeTitle.parentElement.classList.add("ff-alternative")
        }
      }
    }
  );
}
